import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";

export const ClassxArchivotxt = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [activo1, setActivo1] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [uno, setUno] = useState();
  const [dos, setDos] = useState();
  const [tres, setTres] = useState();
  const [cuatro, setCuatro] = useState();
  const [valorto, setValorto] = useState();
  const [values, setValues] = useState({
    idpuc: "",
    descripcion: "",
    puc: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtDescrip = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();
  const txtFile = useRef();

  const onChange = (event) => {
    let one;
    let doss;
    let tress;
    let cuatros;
    if (event.target.name === "uno") {
      one = txt1.current.value;
      setUno(one);
      setActivo1(true);
    } else if (event.target.name === "dos") {
      doss = txt2.current.value;
      setDos(doss);
    } else if (event.target.name === "tres") {
      tress = txt3.current.value;
      setTres(tress);
    } else if (event.target.name === "cuatro") {
      cuatros = txt4.current.value;
      setCuatro(cuatros);
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      txt1.current.value.trim() === "" &&
      txt2.current.value === "" &&
      txt3.current.value === "" &&
      txt4.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Clasificador Presupuestario no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txt1.current.focus();
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Descripción del Clasificador Presupuestario no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/actualizarpucxarchivo`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtIdd.current.value),
      descr: txtDescrip.current.value.trim(),
      pu:
        operacion === 1
          ? uno + dos + tres + cuatro
          : operacion === 2 && activo1 === true
          ? uno + dos + tres + cuatro
          : valorto,
      idef: 0,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idpuc: "",
      descripcion: "",
      puc: "",
    });
    setActivate(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const handleChangeFile = (event) => {
    var resp = [];
    var archivo = event.target.files[0];
    if (!archivo) {
      return;
    }
    var lector = new FileReader();

    lector.readAsText(archivo);
    //lector.onload = cargarArchivo(event);
    lector.onload = function (e) {
      var contenido = e.target.result;
      var lineas = contenido.split("\n");
      setActivate(true);
      /* var resp = validarCamposArchivo(lineas); */
      if (resp[0] === false) {
        txtFile.current.value = "";
        setActivate(false);
      } else {
        /*  var cade = cargarCamposArchivo(lineas); */
        /* setValues(cade) */
        setDeshabilitado(false);
        setActivate(false);
      }
    };
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 5
              ? "Cargar Clasificador Presupuestario por Archivo TXT."
              : ""}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <div className="container-fluid bg-light rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="col-md-12 py-1"></div>

              <div className="col-md-10 mx-auto">
                <label className="form-label" for="customFile">
                  Carga de Archivo TXT
                </label>
                <input
                  type="file"
                  ref={txtFile}
                  accept=".txt"
                  onChange={handleChangeFile}
                  className="form-control"
                  id="customFile"
                />
              </div>

              <div className="col-md-12 py-1"></div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/presupuesto/modalClassXarchivo.js